import React, { Fragment } from 'react';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { Hidden } from '@material-ui/core';
import { get } from 'lodash';
import {
  COMPONENT_GRID_CONTAINER,
  COMPONENT_GRID_BLOCK,
  COMPONENT_NAME,
} from './locators';
import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import CustomLink from '../../../components/atoms/Link';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import { pageContentType } from '../../../utils/getContentType';
import { createDynamicLabels } from '../../../../../src/utils/analytics';
import useStyles from './style';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { palette } from '../../../../styles/themes/vad/palette';
import { ATTRIBUTE_TYPE, EVENT_LISTING_TEMPLATE_ID, EVENT_TYPE } from '../../../../constants';
import Box from '../../../components/molecules/Box';
import Picture from '../../../components/atoms/Picture';

const Breadcrumbs = props => {
  const { customContentList: BreadcrumbList } = props.fields;
  const params = props.params;
  const includePageHeading = params ? params.includePageHeading : false;
  const supergraphicImage = includePageHeading ? params.supergraphicImage : null;
  const bgImage = supergraphicImage ? supergraphicImage.slice(supergraphicImage.indexOf('{') + 1, supergraphicImage.indexOf('}')).replace(/-/g, '') + '.ashx' : ''
  const sitecoreContext = props.sitecoreContext;
  const SEPERATOR = '/';
  const classes = useStyles({ ...params, bgImage });

  const contentType = pageContentType({ sitecoreContext }).toLowerCase();
  const eventListingTemplateId = get(sitecoreContext, 'route.templateId', '');
  const eventAdCalenderLogo = get(sitecoreContext, 'route.fields.eventAdCalenderLogo.value.src', '');
  const eventAdCalenderLogoMobile = get(sitecoreContext, 'route.fields.eventAdCalenderLogoMobile.value.src', '');
  let title =
    get(sitecoreContext, 'route.fields.pageHeading.value', '') ? get(sitecoreContext, 'route.fields.pageHeading', '') : get(sitecoreContext, 'route.fields.name', '');
  if (contentType === ATTRIBUTE_TYPE) {
    title = { value: get(sitecoreContext, 'tag', '') };
  }
  const BreadcrumbListLength = BreadcrumbList ? BreadcrumbList.length : 0;

  return (
    <div className="breadcrumbWrapper">
      <Grid container={includePageHeading} className={includePageHeading ? classes.pageHeadingWrapper : classes.root} data-locator={COMPONENT_GRID_BLOCK}>
        <Grid container spacing={0} data-locator={COMPONENT_GRID_CONTAINER}>
          <Grid item xs={12}>
            <nav aria-label="breadcrumb" className={classes.breadcrumbs}
              data-locator={COMPONENT_NAME}>
              <ol itemScope="itemScope" itemType="https://schema.org/BreadcrumbList" aria-label="breadcrumb">
                {BreadcrumbList &&
                  BreadcrumbList.length > 0 &&
                  BreadcrumbList.map((item, index) => {
                    const { displayName, link } = item;
                    if (index < BreadcrumbListLength - 1) {
                      return (
                        <Fragment key={index}>
                          <li
                            itemProp="itemListElement"
                            itemScope="itemScope"
                            itemType="https://schema.org/ListItem"
                          >
                            <CustomLink
                              key={index}
                              id={index}
                              customHref={link}
                              isCustom={true}
                              isBreadcrumb={true}
                              hoverColor={palette.text.primary}
                              linkColor={palette.text.secondary}
                              aria-label={displayName}
                              data-id={get(
                                analyticsData,
                                'dataIds.pageBodyNavLinkClick',
                                ''
                              )}
                              data-link={createDynamicLabels([
                                getPageName(props),
                                getComponentName(props),
                                `${get(
                                  analyticsData,
                                  'dataLinksText.breadCrumbLink',
                                  ''
                                )}-${displayName}`,
                              ])}
                            >
                              {displayName && (
                                <>
                                  <Typography variant="body2" component="span" itemProp="name">
                                    {displayName}
                                  </Typography>
                                </>
                              )}
                            </CustomLink>
                            <meta itemProp="position" content={index + 1} />
                          </li>
                          <li className="MuiBreadcrumbs-separator">
                            <Typography variant="body2" component="span">
                              {SEPERATOR}
                            </Typography>
                          </li>
                        </Fragment>
                      );
                    } else {
                      return (
                        displayName && (
                          <Fragment key={index}>
                            <li itemProp="itemListElement"
                              itemScope="itemScope"
                              itemType="https://schema.org/ListItem"
                            >
                              <Typography
                                variant="body2"
                                component="span"
                                className={classes.lastBreadcrumb}
                                itemProp="name"
                              >
                                {displayName}
                              </Typography>
                              <meta itemProp="position" content={index + 1} />
                            </li>
                          </Fragment>
                        )
                      );
                    }
                  })}
              </ol>
            </nav>
          </Grid>
        </Grid>

        {includePageHeading &&
          <Grid container spacing={0}>
            <Grid item xs={12} className={contentType === EVENT_TYPE && eventListingTemplateId === EVENT_LISTING_TEMPLATE_ID && classes.eventListingLogoWrapper}>
              <Typography wordBreak title={title.value} className={classes.headingTitle} variant="h2" component="h1" gutterBottom={false}>
                {title && <Text field={title} />}
              </Typography>
              {eventListingTemplateId === EVENT_LISTING_TEMPLATE_ID && contentType === EVENT_TYPE &&
                <>
                  <Hidden mdDown implementation="css">
                    <Box pb={{ xs: 5 }} className={classes.imageWrapper}>
                      <Picture
                        media={{
                          image: {
                            value: {
                              src: eventAdCalenderLogo,
                            },
                          },
                          renditionNeeded: false,
                          fallbackBackgroundNeeded: false,
                        }}
                        isParalax={false}
                        alternateAltText={title && title.value}
                      />
                    </Box>
                  </Hidden>
                  <Hidden lgUp implementation="css">
                    <Box pb={{ xs: 5 }} className={classes.imageWrapper}>
                      <Picture
                        media={{
                          image: {
                            value: {
                              src: eventAdCalenderLogoMobile,
                            },
                          },
                          renditionNeeded: false,
                          fallbackBackgroundNeeded: false,
                        }}
                        alternateAltText={title && title.value}
                      />
                    </Box>
                  </Hidden>
                </>
              }

            </Grid>
          </Grid>
        }
      </Grid>
    </div>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(Breadcrumbs))
);